export default __webpack_public_path__ + "static/media/1.20ccd01e.svg";